import { getApiBaseUrl } from "../config/apiBase";
import { apiFetch } from "../config/apiFetch";

/** After a 503, skip further server PDF attempts this session (production Chromium often stays down). */
let serverPdfUnavailable = false;

export function isServerPdfUnavailable(): boolean {
  return serverPdfUnavailable;
}

/**
 * Renders HTML to PDF via the HO API (headless Chromium). Returns null on 503 or network failure so callers can fall back to client-side export.
 */
export async function fetchServerHtmlPdfBlob(html: string, landscape: boolean): Promise<Blob | null> {
  if (serverPdfUnavailable) return null;
  try {
    const res = await apiFetch(`${getApiBaseUrl()}/api/console/render-html-pdf`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ html, landscape }),
    });
    if (res.status === 503) {
      serverPdfUnavailable = true;
      return null;
    }
    if (!res.ok) {
      const ct = res.headers.get("content-type") ?? "";
      let msg = res.statusText;
      if (ct.includes("application/json")) {
        const j = (await res.json().catch(() => null)) as { error?: string } | null;
        if (j?.error) msg = j.error;
      } else {
        const t = await res.text();
        if (t) msg = t.slice(0, 500);
      }
      throw new Error(msg);
    }
    return await res.blob();
  } catch (e) {
    console.warn("[fetchServerHtmlPdfBlob]", e);
    return null;
  }
}
